import { Component } from '@theme/component';
import { CartAddEvent, ThemeEvents } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * Re-renders a product list when the cart changes between empty and populated states.
 *
 * @extends {Component}
 */
class CartDependentProductList extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  /** @param {CartAddEvent | import('@theme/events').CartUpdateEvent} event */
  #handleCartUpdate = (event) => {
    if (event instanceof CartAddEvent && event.detail.data.didError) return;

    const isCurrentlyEmpty = this.dataset.cartEmpty === 'true';
    const itemCount = Number(event.detail?.data?.itemCount);
    const willBeEmpty = event instanceof CartAddEvent ? false : Number.isFinite(itemCount) ? itemCount === 0 : null;

    if (willBeEmpty === null || willBeEmpty === isCurrentlyEmpty || !this.dataset.sectionId) return;
    sectionRenderer.renderSection(this.dataset.sectionId, { cache: false });
  };
}

if (!customElements.get('cart-dependent-product-list')) {
  customElements.define('cart-dependent-product-list', CartDependentProductList);
}
